import { createHttpLink } from '@apollo/client'

export const agentHttpLink = createHttpLink({
  uri: import.meta.env.VITE_AGENT_GRAPHQL,
})

export const reportHttpLink = createHttpLink({
  uri: import.meta.env.VITE_REPORTS_GRAPHQL,
})
